import { gql } from "graphql-request";

const SERVER_DELETE_DOCUMENT = gql`
  mutation SERVER_DeleteDocument($id: ID!) {
    deleteDocument(id: $id)
  }
`;
export default SERVER_DELETE_DOCUMENT;